import { useEffect, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { onCalendarReminder, type CalendarReminder } from '../data/calendar';
import { openHuddleWindow } from '../lib/huddle-window';
import { playHandRaiseChime } from '../lib/sound';
import { Icon } from './Icon';

/**
 * NAPTARBEJEGYZES KEZDODIK (H1) - felugro kartya a kepernyo sarkaban.
 *
 * Hivasnal "Csatlakozas" gombbal: egy kattintas, es mar bent is vagy, nem
 * kell a naptarban vagy a csatornaban keresgelni. Tobb egyszerre is allhat.
 */
export function CalendarReminderPopup() {
  const [items, setItems] = useState<CalendarReminder[]>([]);
  const navigate = useNavigate();

  useEffect(
    () =>
      onCalendarReminder((reminder) => {
        playHandRaiseChime();
        setItems((current) => [
          ...current.filter((item) => item.eventId !== reminder.eventId),
          reminder,
        ]);
      }),
    [],
  );

  if (items.length === 0) return null;
  const dismiss = (eventId: string) =>
    setItems((current) => current.filter((item) => item.eventId !== eventId));

  return (
    <div className="fixed bottom-4 right-4 z-50 flex w-80 max-w-[calc(100vw-2rem)] flex-col gap-2">
      {items.map((item) => {
        const start = new Date(item.startsAt);
        const started = start.getTime() <= Date.now();
        return (
          <div
            key={item.eventId}
            role="alert"
            className="rounded-card border border-accent bg-surface-raised p-3 text-sm shadow-(--shadow-modal)"
          >
            <p className="font-semibold">
              {item.withCall && <Icon name="huddle" size="sm" />} {item.title}
            </p>
            <p className="text-xs text-ink-muted">
              {started
                ? 'Most kezdődik'
                : `Kezdés ${start.toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit' })}-kor`}
            </p>
            <div className="mt-2 flex gap-2">
              {item.withCall && item.channelId && (
                <button
                  type="button"
                  onClick={() => {
                    dismiss(item.eventId);
                    void openHuddleWindow(item.channelId!);
                  }}
                  className="rounded-control bg-accent px-3 py-1.5 text-xs font-semibold text-accent-ink"
                >
                  Csatlakozás
                </button>
              )}
              <button
                type="button"
                onClick={() => {
                  dismiss(item.eventId);
                  void navigate({ to: '/naptar' });
                }}
                className="rounded-control border border-border px-3 py-1.5 text-xs"
              >
                Naptár
              </button>
              <button
                type="button"
                onClick={() => dismiss(item.eventId)}
                className="ml-auto rounded-control px-2 py-1.5 text-xs text-ink-muted hover:bg-surface-hover"
              >
                Bezárás
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
